module.exports = __webpack_public_path__ + "id.6b254ad7.svg";